<app-modal
  [isVisible]="isVisible()"
  [config]="modalConfig"
  [primaryButtonDisabled]="primaryButtonDisabled()"
  [primaryButtonLoading]="primaryButtonLoading()"
  (confirmed)="onModalConfirmed()"
  (cancelled)="onModalCancelled()"
  (secondary)="onModalCancelled()"
  (closed)="onModalClosed()"
>
  <!-- Header Icon -->
  <div class="modal-header-icon">
    <app-icon iconKey="customers" [showLabel]="false"></app-icon>
  </div>

  <!-- Description -->
  <p class="modal-description">
    Create a new customer organization and invite an admin user via email
  </p>

  <!-- Error Message -->
  @if (error()) {
    <div class="modal-error">
      <span>{{ error() }}</span>
      <button type="button" (click)="clearError()">×</button>
    </div>
  }

  <!-- Form Fields -->
  <div class="field">
    <label for="customerOrgName">Organization name</label>
    <input
      id="customerOrgName"
      type="text"
      placeholder="Customer Organization Name"
      [(ngModel)]="organizationName"
      [disabled]="isLoading()"
      (input)="clearError()"
    />
    <small>This will be the name of the customer organization</small>
  </div>

  <div class="field">
    <label for="customerAdminEmail">Admin Email</label>
    <div class="input-wrapper">
      <input
        id="customerAdminEmail"
        type="email"
        placeholder="admin@customer.com"
        [(ngModel)]="adminEmail"
        [disabled]="isLoading()"
        (input)="clearError()"
      />
      <app-icon iconKey="email" [showLabel]="false" class="input-trailing-icon"></app-icon>
    </div>
    <small>An invite email will be sent to this address to set up the admin account</small>
  </div>
</app-modal>
